import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';

const AnimationComponent = ({ url, style, border = false, width, height }) => {
    const [animationData, setAnimationData] = useState(null);
    useEffect(() => {
        const fetchAnimationData = async () => {
            try {
                const response = await fetch(url);
                const data = await response.json();
                setAnimationData(data);
            } catch (error) {
                console.error('Error >>>>>>>>>>> :', error);
            }
        };

        fetchAnimationData();
    }, [url]);
    return (
        <div>
            {animationData ? (
                <Lottie animationData={animationData} loop={true} className={`rounded-lg overflow-hidden ${border ? 'border-2 border-[#0000001A]' : ''} `} style={{ width: style ? "85px" : width, height: style ? '85px' : height, }} />
            ) : (
                <></>
            )}
        </div>
    );
};

export default AnimationComponent;
